import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { MutableRefObject, useEffect, useRef } from 'react'

export const useTrackIsElementVisible = (getTrackProperties: () => any, cb?: any) => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)
  const seenRef = useRef(false)
  useEffect(() => {
    const onScroll = function () {
      const el = ref.current
      if (el && isInViewport(el) && !seenRef.current) {
        seenRef.current = true
        if (getTrackProperties()) trackEvent(TELEMETRY_EVENT_NAMES.IS_VISIBLE, getTrackProperties())
        if (cb) {
          cb()
        }
        document.removeEventListener('scroll', onScroll)
      }
    }
    document.addEventListener('scroll', onScroll)
    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [getTrackProperties, cb])
  return { ref }
}

function isInViewport(el: HTMLDivElement) {
  if (window.getComputedStyle(el).visibility === 'hidden' || window.getComputedStyle(el).display === 'none') {
    return false
  }
  const rect = el.getBoundingClientRect()
  if (!rect || rect.width === 0 || rect.height === 0) {
    return
  }
  const windowHeight = window.innerHeight || document.documentElement.clientHeight

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.top + windowHeight / 2 <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left + 200 <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
